module.exports = __webpack_public_path__ + "img/ewmxcx_01.499ca07f.jpg";